export enum NotificationActionType {
	LINK = 'LINK',
}

export enum NotificationReadStatus {
	ALL = 'ALL',
	READ = 'READ',
	UNREAD = 'UNREAD',
}

export type NotificationLinkAction = {
	type: NotificationActionType.LINK
	label: string
	url: string
}

/**
 * The BE writes a `type` discriminator per action kind and may add kinds the FE does not
 * render yet. The catchall keeps those deserializable; renderers narrow on the enum member.
 */
export type NotificationAction = NotificationLinkAction | { type: string }

export type Notification = {
	id: number
	type: string
	title: string
	description: string | null
	actions: NotificationAction[]
	read: boolean
	readAt: string | null
	createdAt: string | null
}

export type NotificationPreferences = Record<string, Record<string, boolean>>
